<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Students'
    },

    extends: TableView,

    data() {
        const defaultNoDataText =
            'Use the search field to find a relevant student';

        return {
            pageTitle: 'Students',
            importPath: 'students/import-csv',
            noDataText: defaultNoDataText,
            defaultNoDataText
        };
    },

    computed: {
        options() {
            return {
                filters: false,
                pagination: false,
                noDataText: this.noDataText
            };
        },

        labels() {
            return [
                { value: 'firstName', width: '180px' },
                {
                    value: 'lastName',
                    width: '180px'
                },
                { value: 'email', width: '200px' },
                {
                    value: 'stars',
                    width: '200px'
                },
                { value: 'tz', width: '180px' },
                {
                    value: 'phone',
                    width: '200px'
                },
                {
                    value: 'sex',
                    width: '180px',
                    type: 'enum',
                    enumOptions: ['male', 'female']
                },
                {
                    value: 'membershipStatus',
                    width: '200px'
                },
                {
                    value: 'yearOfStudy',
                    width: '180px'
                },
                {
                    value: 'hugs',
                    width: '200px',
                    sortable: false,
                    filterFieldName: 'hugs.number',
                    filter: v => v.map(hug => hug.number).join(', ')
                },
                {
                    value: 'campuses',
                    width: '150px',
                    sortable: false,
                    filterFieldName: 'campuses.name',
                    filter: v => v.map(campus => campus.name).join(', ')
                },
                {
                    value: 'tags',
                    width: '150px',
                    sortable: false,
                    filterFieldName: 'tags.name',
                    filter: v => v.map(tag => tag.name).join(', ')
                },
                {
                    value: 'createdAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                },
                {
                    text: 'Synced At',
                    value: 'syncedWithUniversityApiAt',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'students/index',
            deleteItem: 'students/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/students/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/students/add');
        },

        async fetchItems() {
            this.isLoading = true;

            try {
                const data = {
                    ...this.pagination,
                    filters: this.filters,
                    ...this.additionalFetchData
                };

                const { count, rows, message } = await this.getItems(data);

                this.items = rows;
                this.pagination.total = count;
                this.noDataText = message ? message : this.defaultNoDataText;
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }

            this.isLoading = false;
        }
    }
};
</script>
